import React, { useRef } from 'react';
import { useNavigateAndScroll } from '../../Hooks/useNavigateAndScroll';

// Base URL for S3 bucket forms
const BUCKET_URL = 'https://cipa-website-forms.s3.us-east-2.amazonaws.com';

const PatientForms = () => {
  // Refs and navigation hook inside component
  const barRef = useRef(null);
  const navigateAndScroll = useNavigateAndScroll();

  // (Optional) if you need these later
  const infoCardsData = {
    newPatient: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/New+Pt+registration.webp',
      infoTitle: 'New Patient Registration',
      infoText:
        'Quickly register online for your first visit. Fill out personal, insurance, and health history details to get started with our practice in just a few minutes.',
      path: '/patient-center/new-patient',
    },
    patientForms: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Patient+forms.webp',
      infoTitle: 'Patient Forms',
      infoText:
        'Access all necessary intake and consent forms to streamline your visit. Download, complete, and upload them securely before your appointment.',
      path: '/patient-center/patient-forms',
    },
    refillRequests: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Med+refill.webp',
      infoTitle: 'Refill Requests',
      infoText:
        'Submit medication refill requests online anytime. Our team will process them promptly and notify you when they’re ready for pickup or sent to your pharmacy.',
      path: '/patient-center/refill-requests',
    },
    officePolicies: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Office+Policy.webp',
      infoTitle: 'Office Policies',
      infoText:
        'Review our appointment, cancellation, and billing policies to ensure a smooth experience. Everything you need to know about visits, payments, and patient responsibilities.',
      path: '/patient-center/office-policies',
    },
    faqs: {
      image: 'https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/FAQ.webp',
      infoTitle: "FAQ's",
      infoText:
        'Find quick answers to the most common questions—hours of operation, new patient procedures, after-hours care, and more—all in one place.',
      path: '/patient-center/faqs',
    },
  };

  // Forms data inside component
  const formsData = [
    {
      title: 'Newborn first visit',
      items: [
        { label: 'New patient registration', link: `${BUCKET_URL}/newpatient_registration.pdf` },
        { label: 'Newborn Questionnaire', link: `${BUCKET_URL}/newborn_patient_questionnaire.pdf` },
        { label: 'Privacy policy and consent', link: `${BUCKET_URL}/noticeforprivacypractices.pdf` },
      ],
    },
    {
      title: 'New patient registration',
      items: [
        { label: 'New patient registration', link: `${BUCKET_URL}/newpatient_registration.pdf` },
        { label: 'New patient Questionnaire', link: `${BUCKET_URL}/Newpatient_questionnaire.pdf` },
        { label: 'Privacy policy and consent', link: `${BUCKET_URL}/noticeforprivacypractices.pdf` },
      ],
    },
    {
      title: 'Autism management',
      items: [
        { label: 'M-CHAT-R', link: `${BUCKET_URL}/M-CHAT-R.pdf` },
        { label: 'M-CHAT-R follow up', link: `${BUCKET_URL}/M-CHAT-R_Follow.pdf` },
      ],
    },
    {
      title: 'Anemia management',
      items: [
        { label: 'Anemia Risk 4month', link: `${BUCKET_URL}/Anemia_Risk_4mo.pdf` },
      ],
    },
    {
      title: 'ADHD management',
      items: [
        { label: 'Vanderbilt parents – initial', link: `${BUCKET_URL}/Vanderbilt-Parent_intitial.pdf` },
        { label: 'Vanderbilt teacher – initial', link: `${BUCKET_URL}/Vanderbilt-Teacher_initial.pdf` },
        { label: 'Vanderbilt parent – follow-up', link: `${BUCKET_URL}/Vanderbilt-Parents_Follow-up.pdf` },
        { label: 'Vanderbilt teacher – follow-up', link: `${BUCKET_URL}/Vanderbilt-Teacher_Follow-up.pdf` },
      ],
    },
    {
      title: 'Asthma management',
      items: [
        { label: 'Asthma Control test 4-11 yrs', link: `${BUCKET_URL}/Asthma-Control-Test-4-to-11-yrs.pdf` },
        { label: 'Asthma Control test 12+ yrs', link: `${BUCKET_URL}/Asthma-Control-Test-12yrs_up.pdf` },
      ],
    },
    {
      title: 'Depression management',
      items: [
        { label: 'PHQ-9 A (modified age 11–17)', link: `` },
        { label: 'PHQ-9 Parent report', link: `${BUCKET_URL}/PHQ-9_Parent_Report.pdf` },
      ],
    },
    {
      title: 'Anxiety management',
      items: [
        { label: 'GAD 7', link: `${BUCKET_URL}/GAD-7.fillable_11%2B_yrs.pdf` },
      ],
    },
    {
      title: 'Substance Use management',
      items: [
        { label: 'CRAFFT screening 12-21 yrs (patient only)', link: `${BUCKET_URL}/CRAFFT_Screening_Questions.pdf` },
      ],
    },
    {
      title: 'Concussion management',
      items: [
        { label: 'Symptom screening – parent', link: `${BUCKET_URL}/Concussion_pre-post_injury_parent.pdf` },
        { label: 'Symptom screening – patient (5-12 yrs)', link: `${BUCKET_URL}/Concussion_pre-post_injury_patient_5-_12_yrs.pdf` },
        { label: 'Symptom screening – patient (13-18 yrs)', link: `${BUCKET_URL}/Concussion_pre-post_injury_patient_13-_18_yrs.pdf` },
      ],
    },
  ];

  return (
    <div>
    <div className="relative w-auto z-1 mt-[-70px]">
          <img
            className="w-full h-auto rounded-lg shadow-lg mt-2"
            src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/forms+patient_InPixio.webp"
            alt="Mother and child meeting a doctor"
          />
        </div>
    <div ref={barRef} className="sticky top-0 flex justify-around bg-custom-blue text-white z-50">
        {Object.values(infoCardsData).map((card) => (
          <button
            key={card.infoTitle}
            className="p-1 text-sm cursor-pointer grow-text"
            onClick={() => navigateAndScroll(card.path, card.infoTitle)}
          >
            {card.infoTitle}
          </button>
        ))}
      </div>
    <div ref={barRef} className="w-full px-4 py-8 sm:px-6 lg:px-64">
      {/* Title */}
      <h2 className="text-4xl font-bold text-gray-800 mb-2">Patient Forms</h2>
      <hr className="border-t-2 border-blue-500 mb-6" />
      <p className="text-black mb-4">
        Please find below the list of all documents and screening questionnaires needed for the patient visits.
      </p>

      <ol className="list-decimal list-outside ml-6 space-y-6 text-gray-600">
        {formsData.map((section) => (
          <li key={section.title}>
            <span className="font-bold">{section.title}</span>
            <ol className="list-[lower-alpha] list-outside ml-6 mt-2 space-y-2">
              {section.items.map((item, j) => (
                <li key={j}>
                  <a
                    href={item.link}
                    className="text-blue-600 underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ol>
          </li>
        ))}
      </ol>
    </div>
    </div>
  );
};

export default PatientForms;
